






































































































import { Component, Prop, Vue } from 'vue-property-decorator';

import KeypadVue from './Keypad.vue';
import CombinationLockVue from './CombinationLock.vue';
import WirecutVue from './Wirecut.vue';
import TextVue from './Text.vue';
import LaptopVue from './Laptop.vue';
import CryptexVue from './Cryptex.vue';
import HintsVue from './Hints.vue';
import { Puzzle } from '../../../engine/Puzzle';


@Component({
    components: {
        KeypadVue,
        CombinationLockVue,
        WirecutVue,
        TextVue,
        LaptopVue,
        CryptexVue,
        HintsVue,
    },
})
export default class PuzzleVue extends Vue {

    @Prop()
    private puzzle!: Puzzle; 

    private modal_hints = false;


    mounted(){


        console.log(this.puzzle.hints);


    }


    success(){

        this.puzzle.solveEvent();

    }


}

